module.exports = __webpack_public_path__ + "img/title.21431d7b.png";